import { useState } from "react";
import "./flyerAdmin.css";

export default function FlyerAdminLogin(){

  const [email,setEmail] = useState("")
  const [password,setPassword] = useState("")
  const [error,setError] = useState("")

  const handleLogin = ()=>{

    const adminEmail = "admin@memberflyer.com"
    const adminPassword = "flyer@876"

    if(email === adminEmail && password === adminPassword){

      localStorage.setItem("flyerAdmin",true)

      window.location="/flyer-admin-dashboard"

    }else{
      setError("Invalid email or password")
    }

  }

  return(

    <div className="adminLoginContainer">

      <div className="adminLoginCard">

        <h1 className="adminTitle">
          Flyer Admin
        </h1>

        <p className="adminSubTitle">
          Secure Management Portal
        </p>

        <input
          type="email"
          placeholder="Admin Email"
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e)=>setPassword(e.target.value)}
        />

        {error && <p className="errorText">{error}</p>}

        <button onClick={handleLogin}>
          Login to Dashboard
        </button>

      </div>

    </div>

  )

}